// extracted by mini-css-extract-plugin
export default {"container":"ExpensesBreakdownChart_container__JXPKn","title":"ExpensesBreakdownChart_title__pRSCd"};